
import React from "react";
import { Tooltip, tooltipClasses } from "@mui/material";
import styled from "@emotion/styled";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => {
  const tooltipColor = "var(--color-dark)";
  return {
    [`& .${tooltipClasses.arrow}`]: {
      color: tooltipColor,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: tooltipColor,
      color: 'var(--color-white)',
      fontSize: "0.7rem",
      textAlign: "center",
      fontWeight: 500
    },
  };
});

export default BootstrapTooltip;
